
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"

import SureViewIcon from "@/components/SureViewIcon.vue"

@Component({
	components: {
		"sv-icon": SureViewIcon
	}
})
export default class SkeletonLoader extends Vue {
	@Prop({ default: false })
	loading!: any;

	@Prop({ type: String, default: "md" })
	public size!: string;
}

